import { viVN_MaterialInformation } from './information';
import { viVN_MaterialManagement } from './management';

export const viVN_Material = {
  ...viVN_MaterialInformation,
  ...viVN_MaterialManagement
};
